import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, Button, Container, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import axios from 'axios';
import { useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import Buildings from "../assets/images/BuildingIcons.png";
import ExpertAdvice from "../assets/images/support.png";
import QuickQuery from "../assets/images/updates.png";


import { configUrl } from '../config';
import { Footer } from '../MarketingSiteComponents/Footer';
import { Header } from '../MarketingSiteComponents/Header';

import whatsappbackground from '../assets/images/whatsappbackground.png';
import ReviewSection from '../MarketingSiteComponents/ReviewSection';
import WhatsappSubscription from '../MarketingSiteComponents/WhatsappSubscription';
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,

    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};
const Socialupdates = ({ onHandleExplore, handleShowSubscription, onOpenPackagesModal, onPricingClick, isLoggedIn, handleShowSubcription }) => {
    const hasFetchedSubscriptions = useRef(false);
    const hasFetchedLandingCounts = useRef(false);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const { referralCode } = useParams();
    const [openModal, setOpenModal] = useState(false);
    // const [showCheckout, setShowCheckout] = useState(false);
    // const [open, setOpen] = useState(false);
    // const [alertMessage, setAlertMessage] = useState("");
    // const [severity, setSeverity] = useState("success");
    // const razorpay_key = configUrl.razorPayKey;
    axios.defaults.headers.common = {
        providerId: configUrl.MediNeerProviderId,
        contentProviderIds: configUrl.MediNeerContentProviderIds
    };
    // const [formData, setFormData] = useState({
    //     name: '',
    //     mobile: '',
    //     email: 'demo@medineer.ai',
    //     course: '',
    //     examYear: '',
    // });

    const [subscriptions, setSubscriptions] = useState(null);
    const [allCounts, setAllCounts] = useState(null);
    const [loadingSignUp, setSignUpLoading] = useState(false);

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log('Form submitted:', formData);
    // };

    let freeResourceId = 4;

    const series = {
        text: "WhatsAppSocialUpdates",
        subscriptionTypeId: null,
        courseId: null,
        price: 500,
        ResourceTypeIdData: 4
    };

    // const showAlert = (message, type = "error") => {
    //     setAlertMessage(message);
    //     setSeverity(type);
    //     setOpen(true);
    // };

    // const handleClose = (_, reason) => {
    //     if (reason === "clickaway") return;
    //     setOpen(false);
    // };
    // const loadRazorpayScript = () => {
    //     return new Promise((resolve) => {
    //         const script = document.createElement("script");
    //         script.src = "https://checkout.razorpay.com/v1/checkout.js";
    //         script.onload = () => resolve(true);
    //         script.onerror = () => resolve(false);
    //         document.body.appendChild(script);
    //     });
    // };
    // const createOrder = async (amount) => {
    //     try {
    //         const response = await axios.post(`${configUrl.AssessmentServer}/api/Payments/createOrder/${amount}`);
    //         return response.data.orderId;
    //     } catch (error) {
    //         console.error("Error creating order:", error);
    //         //return null;
    //     }
    // };
    // const sendUserSignupInfoEmail = async (formData) => {
    //     try {
    //         const name = formData.name?.toString() ?? "";
    //         const mobile = formData.mobile?.toString() ?? "";
    //         const response = await axios.post(
    //             `${configUrl.AssessmentServer}/api/Coupon/whatsAppSubscriptionEmail/${encodeURIComponent(name)}/${encodeURIComponent(mobile)}`
    //         );

    //         console.log(response.data);
    //     } catch (error) {
    //         console.error("Error sending data:", error);
    //     }
    // };

    // const verify = async (response, couponId, discountedPrice) => {

    //     let valid = false;
    //     console.log("paymentreponse", response);
    //     const paymentData = {
    //         razorpayOrderId: response.razorpay_order_id,
    //         razorpayPaymentId: response.razorpay_payment_id,
    //         razorpaySignature: response.razorpay_signature,
    //     };

    //     const finalAmount = discountedPrice == null ? series.price : discountedPrice;
    //     const paymentInfo = {
    //         providerId: configUrl.MediNeerProviderId,
    //         // courseId: series.courseId,  //courseId;,
    //         ResourceId: series?.courseId,
    //         ResourceTypeId: series?.ResourceTypeIdData ?? 3,   // will decide trough navigation BSS@121 4,3,2,0
    //         price: finalAmount || 0,//100, //price;,
    //         paymentMethod: null,
    //         couponCodeId: couponId
    //     }
    //     let request = {};
    //     request.paymentVerification = paymentData;
    //     request.paymentInfo = paymentInfo;

    //     // console.log("data", request, studentInfo);
    //     try {
    //         let isWhatsappJoinPage = true;
    //         await sendUserSignupInfoEmail(formData);
    //         navigate('/success', { state: { userName: null, password: null, isWhatsappJoinPage } })
    //         valid = true;
    //     } catch (error) {
    //         console.error("Error verifying payment:", error);
    //     }


    //     return valid;
    // }
    // const initiatePayment = async (couponId, discountedPrice) => {
    //     const isScriptLoaded = await loadRazorpayScript();

    //     if (!isScriptLoaded) {
    //         showAlert("Failed to load.Please check your connection");
    //         return;
    //     }

    //     const amount = discountedPrice || 0; // Example amount, replace with actual value
    //     const orderId = await createOrder(discountedPrice || 0);

    //     if (!orderId) {
    //         showAlert("Failed to create order. Please try again.");
    //         return;
    //     }

    //     const options = {
    //         key: razorpay_key,
    //         amount: amount * 100,
    //         currency: "INR",
    //         name: "Splayndid",
    //         description: "Course Purchase",
    //         order_id: orderId,

    //         handler: async (res) => {
    //             await verify(res, couponId, discountedPrice);
    //         },

    //         prefill: {
    //             name: formData.name,
    //             email: formData.email,
    //             contact: formData.mobile,
    //         },

    //         theme: {
    //             color: "#3399cc",
    //         },

    //         config: {
    //             display: {
    //                 hide: [
    //                     { method: "card" },
    //                     { method: "netbanking" },
    //                     { method: "wallet" },
    //                     { method: "emi" },
    //                     { method: "paylater" }
    //                 ]
    //             }
    //         }
    //     };


    //     const paymentObject = new window.Razorpay(options);
    //     paymentObject.open();
    // };
    // const onNextHandle = async () => {
    //     setSignUpLoading(true);
    //     const subscription = await getAllSubscriptionsService();
    //     console.log(subscription, '-subs respincp')

    //     const ResourceTypeId = 4;
    //     setSignUpLoading(false);
    // };
    // const handleJoinWhatsapp = () => {
    //     window.open(
    //         "https://chat.whatsapp.com/GCVRkB4VZK86eFQaK6vyj4?mode=ac_t",
    //         "_blank"
    //     );
    // };
    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     if (name === "mobile") {
    //         // Allow only digits and maximum 10 characters
    //         const mobile = value.replace(/\D/g, "").slice(0, 10);

    //         setFormData((prev) => ({
    //             ...prev,
    //             mobile,
    //         }));
    //         return;
    //     }

    //     setFormData((prev) => ({
    //         ...prev,
    //         [name]: value,
    //     }));
    // };
    // const CPFiltersValues = null;
    // const handleFormSubmit = async () => {
    //     if (!formData.name.trim()) {
    //         showAlert("Please enter your name");
    //         return;
    //     }

    //     if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
    //         showAlert("Please enter a valid mobile number");
    //         return;
    //     }

    //     setOpenModal(false);
    //     await sendUserSignupInfoEmail(formData);
    //     initiatePayment(1, 500);
    // };
    // const handleHideCheckout = () => {

    //     setShowCheckout(false);
    // };
    return (
        <Box id="hero" sx={{
            // background: 'linear-gradient(135deg, hsl(210 100% 15%), hsl(210 80% 25%))', 
            color: 'white',
            position: 'relative',
            overflow: 'hidden',
            pt: { xs: 8, md: 8.8 },
            pb: 0
        }}>
            {/* <Box sx={{ position: 'absolute', inset: 0, backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLW9wYWNpdHk9Ii4wNSIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9nPjwvc3ZnPg==')`, opacity: 0.1 }} /> */}
            <Header isHideOptions={true} />
            <Box
                sx={{
                    backgroundImage: `url(${whatsappbackground})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    textAlign: "center",
                    py: {
                        xs: 4,
                        md: 10,
                    },
                    px: 2,
                    color: "#fff",
                }}
            >

                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        bgcolor: "rgba(0,0,0,.45)"
                    }}
                />

                <Container sx={{ position: "relative", zIndex: 2 }}>

                    <Typography
                        sx={{
                            fontSize: {
                                xs: 28,
                                md: 44,
                            },
                            lineHeight: 1.2,
                            fontWeight: 700,
                            fontFamily: "Poppins",
                        }}
                    >
                        Never Miss an Admission Update
                    </Typography>

                    <Typography
                        sx={{
                            mt: 1,
                            mb: 2,
                            fontSize: {
                                xs: 18,
                                md: 22,
                            },
                            lineHeight: 1.35,
                            px: {
                                xs: 1,
                                md: 0,
                            },
                        }}
                    >
                        Join our exclusive WhatsApp group for real-time guidance
                    </Typography>
                    <Button
                        size="large"
                        variant="contained"
                        disableRipple
                        // startIcon={<WhatsAppIcon />}
                        endIcon={
                            <Box
                                component="span"
                                sx={{
                                    display: "inline-block",
                                    animation: "handBounce 1s infinite",
                                    "@keyframes handBounce": {
                                        "0%,100%": {
                                            transform: "translateY(0)",
                                        },
                                        "50%": {
                                            transform: "translateY(4px)",
                                        },
                                    },
                                }}
                            >
                                👇
                            </Box>
                        }
                        sx={{
                            bgcolor: "#FFC107",
                            px: 6,
                            py: 1.8,
                            borderRadius: 2,
                            fontSize: {
                                xs: 18,
                                md: 24
                            },
                            textTransform: "none",
                            cursor: "default !important",
                            "&:hover": {
                                bgcolor: "#FFC107",
                                cursor: "default !important",
                            }
                        }}
                    // onClick={() => setOpenModal(true)}

                    >
                        ₹ <span style={{ fontWeight: 600 }}> 500</span>&nbsp;only
                    </Button>

                    <Box mt={4}>
                        <Button
                            size="large"
                            variant="contained"
                            startIcon={<WhatsAppIcon fontSize='24'
                            />}
                            sx={{
                                bgcolor: "#1FAE4B",
                                color: "#fff",
                                textTransform: 'capitalize',
                                width: {
                                    xs: "100%",
                                    sm: "auto"
                                },
                                maxWidth: 460,
                                py: {
                                    xs: 1.2,
                                    md: 1.5
                                },
                                fontSize: {
                                    xs: 16,
                                    md: 20
                                },
                                borderRadius: 2,
                                fontWeight: 700,
                                "&:hover": {
                                    bgcolor: "#1FAE4B"
                                }
                            }}
                            // onClick={handleJoinWhatsapp}
                            onClick={() => setOpenModal(true)}
                        >
                            Subscribe & Join Now
                        </Button>
                    </Box>

                </Container>

            </Box>
            {/* feature section */}
            <Box
                sx={{
                    bgcolor: "#fff",
                    mt: -1,
                    borderTop: "1px solid #eee",
                    borderBottom: "1px solid #eee",
                    boxShadow: "0 6px 20px rgba(0,0,0,.08)",
                }}
            >
                <Grid container>
                    {[
                        {
                            icon: <WhatsAppIcon sx={{
                                fontSize: {
                                    xs: 40,
                                    md: 55
                                },
                                color: "#25D366"
                            }} />,
                            title: "Admission\nAlerts & Updates",
                        },
                        {
                            icon: <Box
                                component="img"
                                src={Buildings}
                                alt="Buildings"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />,
                            title: "College &\nBranch Insights",
                        },
                        {
                            icon: (<Box
                                component="img"
                                src={ExpertAdvice}
                                alt="Expert Advice"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />),
                            title: "Expert Advice\n& Guidance",
                        },
                        {
                            icon: (<Box
                                component="img"
                                src={QuickQuery}
                                alt="Quick Query"
                                sx={{
                                    width: { xs: 40, md: 55 },
                                    height: { xs: 40, md: 55 },
                                    objectFit: "contain",
                                }}
                            />),
                            title: "Quick Query\nResolution",
                        },
                    ].map((item, index) => (
                        <Grid item xs={6} md={3} key={index}>
                            <Box
                                sx={{
                                    py: 4,
                                    px: 2,
                                    textAlign: "center",
                                    position: "relative",
                                    fontSize: 60,
                                    "&::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: "20%",
                                        right: 0,
                                        width: "1px",
                                        height: "60%",
                                        bgcolor: "#d8d8d8",
                                        display: {
                                            xs: index % 2 === 0 ? "block" : "none",
                                            md: index !== 3 ? "block" : "none",
                                        },
                                    },
                                }}
                            >
                                {item.icon}

                                <Typography
                                    sx={{
                                        mt: 1,
                                        fontWeight: 800,
                                        fontSize: {
                                            xs: 14,
                                            md: 19
                                        },
                                        color: "#012248",
                                        whiteSpace: "pre-line",
                                        lineHeight: 1.3,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            {/* How It Works */}
            <Box
                sx={{
                    py: 5,
                    px: 2,
                    bgcolor: "#fff",
                }}
            >
                <Container maxWidth="md">

                    <Box
                        sx={{
                            position: "relative",
                            textAlign: "center",
                            mb: 4,

                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                width: "38%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },

                            "&::after": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                right: 0,
                                width: "38%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                px: 2,
                                bgcolor: "#fff",
                                position: "relative",
                                zIndex: 1,
                                color: "#0b4b91",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 22,
                                    md: 28,
                                },
                                fontFamily: "Poppins",
                            }}
                        >
                            How It Works
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            border: "1px solid #d6dce5",
                            borderRadius: 2,
                            overflow: "hidden",
                            background: "linear-gradient(to bottom,#ffffff,#f6f8fb)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            flexWrap: "nowrap", // <-- change
                        }}
                    >

                        {[
                            {
                                color: "#1ca64b",
                                icon: "✅",
                                number: null,
                                text: "Subscribe",
                            },
                            {
                                color: "#27ae60",
                                icon: null,
                                number: 2,
                                text: "Join Group",
                            },
                            {
                                color: "#f4b400",
                                icon: "⚡",
                                number: null,
                                text: "Get Updates",
                            },
                        ].map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    flex: 1,
                                    minWidth: 0, // <-- instead of 100%
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    px: { xs: 0.5, sm: 1 },
                                    py: 1.5,
                                    position: "relative",
                                }}
                            >
                                <Box
                                    sx={{
                                        borderRadius: "50%",
                                        bgcolor: item.color,
                                        color: "#fff",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: 700,
                                        mr: 1.5,
                                        width: {
                                            xs: 28,
                                            md: 34
                                        },
                                        height: {
                                            xs: 28,
                                            md: 34
                                        },
                                        fontSize: {
                                            xs: 14,
                                            md: 18
                                        }
                                    }}
                                >
                                    {item.number || item.icon}
                                </Box>

                                <Typography
                                    sx={{
                                        fontWeight: 700,
                                        color: "#0b4b91",
                                        fontFamily: "Poppins",
                                        fontSize: {
                                            xs: 14,
                                            md: 18
                                        },
                                    }}
                                >
                                    {item.text}
                                </Typography>

                                {index !== 2 && (
                                    <Typography
                                        sx={{
                                            position: "absolute",
                                            right: -12,
                                            color: "#c4c4c4",
                                            fontSize: 26,
                                            display: {
                                                xs: "none",
                                                sm: "block",
                                            },
                                        }}
                                    >
                                        ❯
                                    </Typography>
                                )}
                            </Box>
                        ))}

                    </Box>
                </Container>
            </Box>
            {/* Testimonials */}
            <Box
                sx={{
                    // py: 5,
                    px: 2,
                    bgcolor: "#fff",
                }}
            >
                <Container maxWidth="md">

                    {/* Heading */}
                    {/* <Box
                        sx={{
                            position: "relative",
                            textAlign: "center",
                            mb: 4,

                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },

                            "&::after": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                right: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                px: 2,
                                bgcolor: "#fff",
                                position: "relative",
                                zIndex: 1,
                                color: "#0b4b91",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 22,
                                    md: 28,
                                },
                                fontFamily: "Poppins",
                            }}
                        >
                            What Students Say
                        </Typography>
                    </Box> */}
                    <ReviewSection isSocialPage={true} />
                    {/* <Box
                        sx={{
                            background: "linear-gradient(180deg,#2f72c6,#1f63b8)",
                            borderRadius: 2,
                            p: 2,
                            boxShadow: "0 8px 18px rgba(0,0,0,.18)",
                            "& .slick-dots": {
                                bottom: "-28px",
                            },

                            "& .slick-dots li button:before": {
                                color: "#fff",
                                opacity: 0.5,
                                fontSize: "12px",
                            },

                            "& .slick-dots li.slick-active button:before": {
                                color: "#fff",
                                opacity: 1,
                            },

                            "& .slick-slide > div": {
                                padding: "0 8px",
                            },

                            "& .slick-list": {
                                margin: "0 -8px",
                            },
                        }}
                    >
                        <Slider {...settings}>

                            {[
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                },
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                },
                                {
                                    img: student2,
                                    quote: "“Got the best advice\nfor my admission!”",
                                    name: "Rajesh M."
                                },
                                {
                                    img: student1,
                                    quote: "“Very helpful and\nquick updates!”",
                                    name: "Ananya S."
                                }
                            ].map((item, index) => (
                                <Box key={index} px={1}>
                                    <Box
                                        sx={{
                                            bgcolor: "#fff",
                                            borderRadius: 2,
                                            p: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            minHeight: 150,
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            key={index}
                                        >
                                            <Box
                                                sx={{
                                                    bgcolor: "#fff",
                                                    borderRadius: 1,
                                                    p: 2,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    minHeight: 140,
                                                }}
                                            >

                                                <Box
                                                    sx={{
                                                        flex: 1,
                                                        textAlign: "center",
                                                        pr: 2,
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: "Poppins",
                                                            fontWeight: 600,
                                                            fontStyle: "italic",
                                                            color: "#222",
                                                            fontSize: 18,
                                                            lineHeight: 1.45,
                                                            whiteSpace: "pre-line",
                                                        }}
                                                    >
                                                        {item.quote}
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            mt: 2,
                                                            fontSize: 16,
                                                            color: "#222",
                                                            fontWeight: 500,
                                                        }}
                                                    >
                                                        - {item.name}
                                                    </Typography>
                                                </Box>

                                                <Box
                                                    component="img"
                                                    src={item.img}
                                                    sx={{
                                                        width: 105,
                                                        height: 105,
                                                        borderRadius: 1,
                                                        objectFit: "cover",
                                                        flexShrink: 0,
                                                    }}
                                                />

                                            </Box>
                                        </Grid>

                                    </Box>
                                </Box>
                            ))}
                        </Slider>

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 1.2,
                                mt: 2,
                            }}
                        ></Box>

                    </Box> */}

                </Container>
            </Box>
            {/* Bottom CTA */}
            <Box
                sx={{
                    py: 5,
                    px: 2,
                    bgcolor: "#fff",
                }}
            >
                <Container maxWidth="md">
                    {/* Heading */}
                    <Box
                        sx={{
                            position: "relative",
                            textAlign: "center",
                            mb: 4,

                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                left: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },

                            "&::after": {
                                content: '""',
                                position: "absolute",
                                top: "50%",
                                right: 0,
                                width: "34%",
                                height: "2px",
                                bgcolor: "#d6dce5",
                                transform: "translateY(-50%)",
                            },
                        }}
                    >
                        <Typography
                            sx={{
                                display: "inline-block",
                                px: 2,
                                bgcolor: "#fff",
                                position: "relative",
                                zIndex: 1,
                                color: "#0b4b91",
                                fontWeight: 700,
                                fontSize: {
                                    xs: 22,
                                    md: 28,
                                },
                                fontFamily: "Poppins",
                            }}
                        >
                            Join Now for Just ₹ 500
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        startIcon={<WhatsAppIcon />}
                        sx={{
                            bgcolor: "#1FAE4B",
                            color: "#fff",
                            textTransform: 'capitalize',
                            width: {
                                xs: "100%",
                                sm: "auto"
                            },
                            // maxWidth: 460,
                            py: {
                                xs: 1.2,
                                md: 1.5
                            },
                            fontSize: {
                                xs: 16,
                                md: 20
                            },
                            borderRadius: 2,
                            fontWeight: 700,
                            "&:hover": {
                                bgcolor: "#1FAE4B"
                            }
                        }}
                        // sx={{
                        //     mt: 4,
                        //     bgcolor: "#1ea64b",
                        //     fontSize: 20,
                        //     px: 5,
                        //     py: 1.5,
                        //     textTransform: "none"
                        // }}
                        onClick={() => setOpenModal(true)}
                    >
                        Join Exclusive WhatsApp Group @ ₹ 500
                    </Button>

                </Container>

            </Box>
            <Footer isHideOptions={true} />
            <WhatsappSubscription
                open={openModal}
                onClose={() => setOpenModal(false)}
                title="Join WhatsApp Group"
                price={500}
            />
        </Box >
    );
};
export default Socialupdates;